export default __webpack_public_path__ + "locales/sr-Cyrl-RS/SharingPanel.json?hash=6f7fa16d8aa8f2167204547d4c44a566";